import React from "react";
import { FaCheck } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const PasswordValidation = (props) => {
  const { passwordValidation } = props;
  const {t} = useTranslation();

  return (
    <div className="w-full pb-2 pl-1 md:pl-3">
      <p className="text-lightBlack text-sm font-medium pb-1">{t('passwordMust')}</p>
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="flex flex-row items-center mb-2">
          {passwordValidation.passwordHasEightCharacters ? (
            <FaCheck className="text-green h-3 w-3 mr-1.5" />
          ) : (
            <div
              className={`p-1 border border-gray rounded-full mr-2 bg-passwordGray`}
            />
          )}
          <p
            className={`text-xs font-light ${
              passwordValidation.passwordHasEightCharacters
                ? "text-green"
                : "text-lightBlack"
            }`}
          >
            {t('passwordMinimum')}
          </p>
        </div>

        <div className="flex flex-row items-center mb-2">
          {passwordValidation.passwordHasUpperCaseLetter ? (
            <FaCheck className="text-green h-3 w-3 mr-1.5" />
          ) : (
            <div
              className={`p-1 border border-gray rounded-full mr-2 bg-passwordGray`}
            />
          )}
          <p
            className={`text-xs font-light ${
              passwordValidation.passwordHasUpperCaseLetter
                ? "text-green"
                : "text-lightBlack"
            }`}
          >
            {t('passwordUppercase')}
          </p>
        </div>

        <div className="flex flex-row items-center mb-2">
          {passwordValidation.passwordHasNumber ? (
            <FaCheck className="text-green h-3 w-3 mr-1.5" />
          ) : (
            <div
              className={`p-1 border border-gray rounded-full mr-2 bg-passwordGray`}
            />
          )}
          <p
            className={`text-xs font-light ${
              passwordValidation.passwordHasNumber
                ? "text-green"
                : "text-lightBlack"
            }`}
          >
            {t('passwordInclude')}
          </p>
        </div>

        <div className="flex flex-row items-center mb-2">
          {passwordValidation.passwordHasLowerCaseLetter ? (
            <FaCheck className="text-green h-3 w-3 mr-1.5" />
          ) : (
            <div
              className={`p-1 border border-gray rounded-full mr-2 bg-passwordGray`}
            />
          )}
          <p
            className={`text-xs font-light ${
              passwordValidation.passwordHasLowerCaseLetter
                ? "text-green"
                : "text-lightBlack"
            }`}
          >
            {t('passwordLowercase')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordValidation;
